import { ActionContext } from 'vuex'
import Vue from 'vue'
import apiRoomService from '@/api/roomservice'
import util from '@/utils/classToObject'
import actionsTypes from '@/store/all-action-types'
import types from './all-mutation-types'
import { IRootState, emptyAction, actionEnsure, payloadAction } from '@/store'
import { IRoomserviceState } from './state'
import { buildStateItem } from '@/models/alo/StateItem'
import { IItemPanier, ItemPanier } from '@/models/alo/ItemPanier'
import {formatCurrency} from '@/filters/currency'
import {i18n} from '@/locale/vueI18n'

export class RoomServiceAction {
    
    public [types.ROOM_SERVICES_DATAS_REQUEST](context: ActionContext<IRoomserviceState, IRootState>) {
        return  emptyAction(context,types.ROOM_SERVICES_DATAS_REQUEST,types.ROOM_SERVICES_DATAS_SUCCESS,types.ROOM_SERVICES_DATAS_ERROR,apiRoomService.getAllDatas)    
    }    

    public [types.ROOM_SERVICES_DATAS_ENSURE](context: ActionContext<IRoomserviceState, IRootState>) {
        if(context.state.sectionsList.length == 0){
            return context.dispatch(types.ROOM_SERVICES_DATAS_REQUEST)
        }
        return new Promise((resolve, reject) => {
            resolve()
        })  
    }

    public [types.ROOM_SERVICES_CRENAUX_REQUEST](context: ActionContext<IRoomserviceState, IRootState>) {
        return  emptyAction(context,types.ROOM_SERVICES_CRENAUX_REQUEST,types.ROOM_SERVICES_CRENAUX_SUCCESS,types.ROOM_SERVICES_CRENAUX_ERROR,apiRoomService.getCrenaux)
    }   

    public [types.ROOM_SERVICES_PLAT_SET_SELECTION](context: ActionContext<IRoomserviceState, IRootState>,{selected,ids}:{selected:boolean,ids:Array<number>}) {
        return new Promise((resolve, reject) => {
            context.commit(types.ROOM_SERVICES_PLAT_SET_SELECTION,{selected,ids})
            resolve()
        })
    }

    public [types.ROOM_SERVICES_ARBO_SET_SELECTION](context: ActionContext<IRoomserviceState, IRootState>,{selected,ids}:{selected:boolean,ids:Array<number>}) {
        return new Promise((resolve, reject) => {
            context.commit(types.ROOM_SERVICES_ARBO_SET_SELECTION,{selected,ids})
            resolve()
        })
    }    

    public [types.ROOM_SERVICES_ADD_PANIER](context: ActionContext<IRoomserviceState, IRootState>,item:ItemPanier) {
        return new Promise((resolve, reject) => {
            if(item.qty > 0){
                context.commit(types.ROOM_SERVICES_ADD_PANIER,item)
                //@ts-ignore                
                context.dispatch(actionsTypes.UI_ADD_SNACK_MESSAGE,i18n.tc('Dish.SnackAddCart',item.qty,{plat:Vue.$gt(item.plat).libelle,prix:formatCurrency(item.prixTotalAvecOptions)})) 
            }
            resolve()
        })
    }
    
    public [types.ROOM_SERVICES_UPD_ITEM_COMMENTAIRE](context: ActionContext<IRoomserviceState, IRootState>,{uuid,commentaire}:{uuid:string,commentaire:string}) {
        return new Promise((resolve, reject) => {
            context.commit(types.ROOM_SERVICES_UPD_ITEM_COMMENTAIRE,{uuid,commentaire})
            resolve()
        })
    }

    public [types.ROOM_SERVICES_UPD_ITEM_QTY](context: ActionContext<IRoomserviceState, IRootState>,{uuid,qty}:{uuid:string,qty:number}) {
        return new Promise((resolve, reject) => {
            context.commit(types.ROOM_SERVICES_UPD_ITEM_QTY,{uuid,qty})
            resolve()
        })
    }

    public [types.ROOM_SERVICES_UPD_COMMENTAIRE](context: ActionContext<IRoomserviceState, IRootState>,commentaire:string) {
        return new Promise((resolve, reject) => {
            context.commit(types.ROOM_SERVICES_UPD_COMMENTAIRE,commentaire)
            resolve()
        })
    }

    

    public [types.ROOM_SERVICES_UPD_HEURE_LIVRAISON](context: ActionContext<IRoomserviceState, IRootState>,horaire:string) {
        return new Promise((resolve, reject) => {
            context.commit(types.ROOM_SERVICES_UPD_HEURE_LIVRAISON,horaire)
            resolve()
        })
    }
    
    public [types.ROOM_SERVICES_UPD_CONTACT](context: ActionContext<IRoomserviceState, IRootState>,contact:Array<string>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ROOM_SERVICES_UPD_CONTACT,contact)
            resolve()
        })
    }
    
    public [types.ROOM_SERVICES_UPD_NB_COUVERTS](context: ActionContext<IRoomserviceState, IRootState>,nb:number) {
        return new Promise((resolve, reject) => {
            context.commit(types.ROOM_SERVICES_UPD_NB_COUVERTS,nb)
            resolve()
        })
    }

    public [types.ROOM_SERVICES_UPD_CART_ITEM](context: ActionContext<IRoomserviceState, IRootState>,item:ItemPanier) {
        return new Promise((resolve, reject) => {
            context.commit(types.ROOM_SERVICES_UPD_CART_ITEM,item)
            resolve()
        })
    }

    public [types.ROOM_SERVICES_CLEAR_PANIER](context: ActionContext<IRoomserviceState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.ROOM_SERVICES_CLEAR_PANIER)
            resolve()
        })
    }

    

    
    
    
    

    
}

export default util.classToObject(RoomServiceAction)
